module.exports = __webpack_public_path__ + "img/fig19.6dd303bf.jpg";